<template>
  <bk-bets-list :data-func="getBets" :show-user="true" />
</template>
<script>
  import bkService from '../../../../../services/bk.service'

  import bkBetsList from '../../../../common/bk-bets-list.vue'

  export default {
    name: 'player-bk-bets',
    components: { bkBetsList },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      playerId() {
        return this.$route.params.playerId;
      }
    },
    methods: {
      async getBets(filter) {
        filter.clientId = this.clientId;
        filter.userId = this.playerId;
        return await bkService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/bk-bets.vue